import { render, staticRenderFns } from "./successDonationVoucher.vue?vue&type=template&id=52b0099a&scoped=true"
import script from "./successDonationVoucher.vue?vue&type=script&lang=js"
export * from "./successDonationVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0099a",
  null
  
)

export default component.exports